// ------------------------------------------------------------------------
// Shopify API Calls
// ------------------------------------------------------------------------
(function () {

    'use strict';

    var tail = $.when();

    function enqueue(params, callback) {
        tail = tail.then(function () {
            return $.ajax(params);
        }).then(callback);
    }

    function peek(callback) {
        var params = {
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
        };
        enqueue(params, callback);
    }

    function clear(callback) {
        var params = {
            type: 'POST',
            url: '/cart/clear.js',
            data: '',
            dataType: 'json',
        };
        enqueue(params, callback);
    }

    function slowadd(items, callback) {
        var i;
        for (i = 0; i < items.length; i++) {
            tail = tail.then(function (item) {
                return function () {
                    var quantity = item.quantity || 1;
                    var dataString = 'quantity=' + quantity + '&id=' + item.id;
                    if (item.properties) {
                        $.each(item.properties, function (k, v) {
                            dataString += '&' + encodeURIComponent('properties[' + k + ']') + '=' + encodeURIComponent(v);
                        });
                    }
                    var params = {
                        type: 'POST',
                        url: '/cart/add.js',
                        data: dataString,
                        dataType: 'json',
                    };
                    return $.ajax(params);
                };
            }(items[i]));
        }
        tail = tail.then(callback);
    }

    function slowchange(items, callback) {
        var i;
        for (i = 0; i < items.length; i++) {
            tail = tail.then(function (item) {
                return function () {
                    var quantity = item.quantity || 0;
                    var idString = '';
                    (item['id'] != undefined) ? idString = '&id=' + item.id: idString = '&line=' + item.line;
                    var dataString = 'quantity=' + quantity + '' + idString;
                    if (item.properties) {
                        $.each(item.properties, function (k, v) {
                            dataString += '&' + encodeURIComponent('properties[' + k + ']') + '=' + encodeURIComponent(v);
                        });
                    }
                    var params = {
                        type: 'POST',
                        url: '/cart/change.js',
                        data: dataString,
                        dataType: 'json',
                    };
                    return $.ajax(params);
                };
            }(items[i]));
        }
        tail = tail.then(callback);
    }

    function add(data, callback) {
        var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
        };
        enqueue(params, callback);
    }

    function addfromform(form_id, callback) {
        var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery('#' + form_id).serialize(),
            dataType: 'json',
        };
        enqueue(params, callback);
    }

    function update(data, callback) {
        var params = {
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
        };
        enqueue(params, callback);
    }

    function updateAttributes(data, callback) {
        var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
        };
        enqueue(params, callback);
    }

    function checkout() {
        tail = tail.then(function () {
            window.location.href = '/checkout';
        });
    }

    function redirect(url) {
        tail = tail.then(function () {
            window.location.href = url;
            return $.Deferred().promise(); // return a broken promise to prevent activity on page load
        });
    }

    function clearError(callback) {
        tail = tail.then(null, function (err) {
            callback(err);
            return $.when();
        });
    }



    function exposequeue() {
        return tail;
    }

    window.Tailpipe = {
        clear: clear,
        addItems: slowadd,
        changeItems: slowchange,
        addItemFromData: add,
        addItemFromForm: addfromform,
        checkout: checkout,
        redirect: redirect,
        clearError: clearError,
        updateCart: update,
        updateCartAttributes: updateAttributes,
        getCart: peek,
        /*For safety reasons
        exposeQueue: exposequeue,
        */
    }
}());


function bakeCookie(name, value, days) {
    var expires, date;

    if (days) {
        date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function tasteCookie(name) {
    var nameEQ, ca;
    nameEQ = encodeURIComponent(name) + "=";
    ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function eatCookie(name) {
    bakeCookie(name, "", -1);
}

function getQS() {
    return location.search.substr(1).split('&').reduce(function (a, b) {
        var c = b.split('=');
        if (c[1]) {
            a[decodeURIComponent(c[0])] = decodeURIComponent(c[1]);
        }
        return a;
    }, {});
}

